export const AUTH_TOKEN = "ALEXANDRIA_AUTH_TOKEN";
export const REFRESH_TOKEN = "ALEXANDRIA_REFRESH_TOKEN";
export const USER_ID = "USER_ID";
export const EXPIRE_LOGIN = "EXPIRE_LOGIN";
